namespace GeniuzPOS.Inventory {
    export interface IcStockApproveDisassembleDtRow {
        Id?: number;
        SysDocNo?: string;
        LineItemNo?: number;
        PluCode?: string;
        PluDesc?: string;
        SellUnitRatio?: number;
        SetItemQty?: number;
        SetQty?: number;
        Qty?: number;
        SkuCode?: string;
        SkuQty?: number;
        UnitCost?: number;
        CostValue?: number;
        ExpDate?: string;
        Remark?: string;
        QtyUse?: number;
    }

    export namespace IcStockApproveDisassembleDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PluDesc';
        export const localTextPrefix = 'Inventory.IcStockApproveDisassembleDt';
        export const lookupKey = 'Inventory.IcStockApproveDisassembleDt';

        export function getLookup(): Q.Lookup<IcStockApproveDisassembleDtRow> {
            return Q.getLookup<IcStockApproveDisassembleDtRow>('Inventory.IcStockApproveDisassembleDt');
        }
        export const deletePermission = '2Inventory:การประกอบสินค้า:อนุมัติ:Modify';
        export const insertPermission = '2Inventory:การประกอบสินค้า:อนุมัติ:Modify';
        export const readPermission = '2Inventory:การประกอบสินค้า:อนุมัติ:View';
        export const updatePermission = '2Inventory:การประกอบสินค้า:อนุมัติ:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            LineItemNo = "LineItemNo",
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            SellUnitRatio = "SellUnitRatio",
            SetItemQty = "SetItemQty",
            SetQty = "SetQty",
            Qty = "Qty",
            SkuCode = "SkuCode",
            SkuQty = "SkuQty",
            UnitCost = "UnitCost",
            CostValue = "CostValue",
            ExpDate = "ExpDate",
            Remark = "Remark",
            QtyUse = "QtyUse"
        }
    }
}
